import React, { createContext, MutableRefObject, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthProfile } from "../../app/hooks" // Assuming this hook provides necessary user info
import { store } from '../../app/store' // /app/store';
import Skeleton from '@mui/material/Skeleton';
import patientPin from "../../assets/patienticon.svg";
// --- CHATCORE IMPORTS ---
import {
  BasicStorage,
  ChatMessage,
  ChatProvider,
  ConversationId,
  ConversationRole,
  MessageContentType,
  Participant,
  Presence,
  TypingUsersList,
  UpdateState,
  useChat,
  User,
  UserStatus,
  Sender,
  MessageDirection,
  SenderType,
  MessageStatus,
  IStorage,
  Conversation as Convo,
  

} from "@chatscope/use-chat";

import { GetPopulateStateMethod, ChatService, ServiceState } from '../../features/chatService'//'../../features/PollingChatService'; 
// --- UI AND STYLE IMPORTS ---
import { Divider, Container, Box, Stack, Button, Dialog, DialogContent, DialogTitle, IconButton, Link, Paper, LinearProgress, Typography, CircularProgress } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import "./chatscope-overrides.css";
import {
  MessageModel,
  ConversationContentProps,
  MainContainer,
  ChatContainer,
  ConversationHeader,
  Search,
  ConversationList,
  MessageSeparator,
  Conversation,
  Sidebar,
  ExpansionPanel,
  Avatar,
  MessageList,
  Message,
  MessageInput,
  MessageGroup,
} from '@chatscope/chat-ui-kit-react';

import { nanoid } from '@reduxjs/toolkit';
import { chatscopeApi, useGetChatStateQuery, useGetConversationsQuery, useGetMessagesQuery, useSetReadConversationMutation } from '../../features/useChatSlice';
import { CreateConversationFromRaw, RawConversation, RawConversationOptionalId, RawMessage } from '../../features/chatSelectors';
import { skipToken } from '@reduxjs/toolkit/query';
import { update } from 'lodash';
import { UnAuthorizedMessage } from './UnAuthorizedMessage';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { AIProfile } from "../AI/AIProfile";
import { useAIProfileForPinClicked } from "../AI/AIhook";
import { useLocation, useSearchParams } from 'react-router-dom';
import { NoChatsMessage } from './NoChatsMessage';
import { CircularProgressCentered } from '../../app/components/sharedcomponents';
import { SkeletonWithRetry } from '../../app/components/ProfileFetchError';
import Chip from '@mui/material/Chip';
import './spotlight.css';
import { useInAppMessageAgentMutation } from '../../features/adminSlice';
//import { ChatExample } from './example/example';
//import { ConversationListSideBar } from './example/components/Chat';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { AppLayout, AuthLayout } from '../../App';
import { PatchedChatProvider } from './PatchedChatProvider';
import { PollingChatDataService } from '../../features/pollingChatDataService';

export const ServiceStateContext = createContext<ServiceState | undefined>(
  undefined
);
//export   interface ToggleResponsiveChat { 'convoList': true, 'mainChat': true, 'expansionPanel': true }
/**
 * ChatContent is responsible for consuming the state from ChatProvider 
 * via the useChat() hook and rendering the UI.
 */
export const ChatMessageContent: React.FC<{ conversationListSideBar?: React.ReactNode, conversationHeader?:(activeConversation: Convo<any> | undefined) => React.ReactNode, sidebar?: React.ReactNode }> = ({ conversationListSideBar, sidebar, conversationHeader }) => {
  const { currentMessages, conversations, activeConversation, setActiveConversation, addConversation, sendMessage, getUser, currentMessage, setCurrentMessage, sendTyping, setCurrentUser, currentUser, updateState, service } = useChat();
  const { authStatus, profile: loggedInUserProfile, isLoading: isLoadingLoggedInUserProfile, isSuccess: isSuccessLoggedInUserProfile, isError: isErrorLoggedInUserProfile, error: errorLoggedInUserProfile } = useAuthProfile()
  const profileId = loggedInUserProfile?.id
  const [setReadConversation] = useSetReadConversationMutation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const receiverID = activeConversation && loggedInUserProfile
    ? Number(activeConversation.participants.find((participant) => Number(participant.id) !== loggedInUserProfile.id)?.id)
    : undefined;

  const { aiSummary: AIProfileSummary, authProfile: authProfile, profile: profileToUse, isLoading, isSuccess, isError, error } = useAIProfileForPinClicked(receiverID ? receiverID : skipToken)

  const [serviceState, setServiceState] = useState<ServiceState>((service as ChatService)?.getServiceState() ??
  {
    isLoading: true,
    isError: false,
    isSuccess: false,
    error: undefined,
    data: undefined,
    isInitialized: false
  });

  const { data: serviceData, isLoading: isLoadingChatStateData, isSuccess: isSuccessChatStateData, isInitialized: isInitializedChatStateData, isError: isErrorChatStateData, error: errorChatStateData } = serviceState
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  
  useEffect(() => {
    if (activeConversation?.id) {
      resetUnreadCounter()
    }
  }, [activeConversation?.id])


  useEffect(() => {
    if (service) {
      (service as ChatService).attachSetServiceStateFunc((serviceState: ServiceState) => {
        //if (!serviceState.isInitialized && serviceState.isSuccess && !serviceState?.data?.conversationAddedCount && !serviceState?.data?.messagesAddedCount && serviceState?.data?.latestHandledTimestamp) {// to prevent unnecessary renders after initial retrieve, render on the first retrieve (!serviceState?.data?.latestHandledTimestamp) regardless
        if (!serviceState.isError && serviceState.data?.newMessagesOnly) {
          return
        }
        setServiceState(serviceState)
      })
    }
  }, [service])


  useEffect(() => {
    if (!isInitializedChatStateData || !conversations.length ){//|| conversationIdToOpenWithDefaultdRef.current) {
      return;
    }
    if (activeConversation) {
      return
    }
    //'1' = community journal
    setActiveConversation('1')//conversationIdToOpenWithDefault);
  }, [isInitializedChatStateData, conversations, ]);


  useEffect(() => {
    if (serviceState?.isSuccess && !currentUser) {
      const user = getUser(profileId.toString())
      if (user) {
        setCurrentUser(user);
      }
    }
  }, [currentUser, profileId, setCurrentUser, serviceState, serviceState?.isSuccess]);

  // Get current user data
  const [currentUserAvatar, currentUserName, user] = useMemo(() => {
    if (activeConversation) {
      const otherParticipants = activeConversation.participants.length > 0 ? activeConversation.participants.filter(p => p.id !== profileId?.toString()) : []
      const participant = otherParticipants.length > 0 ? otherParticipants[0] : undefined;
      if (participant) {
        const user = getUser(participant.id);
        if (user) {
          return [<Avatar src={user.avatar} />, user.username, user]
        }
      }
    }

    return [undefined, undefined];

  }, [activeConversation]);

  // Renders a loading state if no conversations have been loaded yet


  // --- HELPER FUNCTIONS ---
  const handleSend = (text: string) => {
    // Logger user (sender)

    const message = new ChatMessage<MessageContentType.TextPlain>({
      id: "",
      content: { body: text },
      contentType: MessageContentType.TextPlain, //.TextHtml,
      sender: new Sender({ id: profileId.toString(), type: SenderType.User }),//senderId: currentUserId,
      direction: MessageDirection.Outgoing,
      status: MessageStatus.Sent
    });

    sendMessage({
      message,
      conversationId: activeConversation?.id ?? 'XYZ',
      senderId: profileId.toString(),
    });

    resetUnreadCounter();

  };

  function resetUnreadCounter() {
    if (authStatus !== 'authenticated') return; // guests can't mark-read (write 403s); skip the noise + round-trip (mirrors markMessageRead's guest guard)
    if (!activeConversation?.id) return;
    setReadConversation({ conversationId: Number(activeConversation?.id), userId: profileId })
  }

  return (
    <>
      <ServiceStateContext.Provider value={serviceState}>
        <MainContainer
          style={{
            width: '100%',
            height: '100%',
          }}
        >

          {conversationListSideBar}

          <ChatContainer onClick={resetUnreadCounter} style={{ display: 'flex' }}>
            {conversationHeader && conversationHeader( activeConversation)}
            {activeConversation && <MessageList>
              {currentMessages.slice(-25).map(
                (g, gIndex, arr) => {
                  return (
                    <MessageGroup key={g.id} direction={g.direction}>
                      <MessageGroup.Messages key={gIndex}>
                        {g.messages.map((m: ChatMessage<MessageContentType>, index) => {
                          // Only show a separator when the date changes from the previous message
                          const prevGroup = arr[gIndex - 1];
                          const prevMessage = prevGroup?.messages[prevGroup.messages.length - 1];
                          const prevDate = prevMessage?.createdTime;
                          const currDate = m.createdTime;
                          const showSeparator = !prevDate ||
                            prevDate.toLocaleDateString() !== currDate.toLocaleDateString() ||
                            (currDate.getTime() - prevDate.getTime() > 30 * 60 * 1000);

                          return (
                            <React.Fragment key={index}>
                              {showSeparator && index === 0 && (
                                <MessageSeparator content={currDate.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })} />
                              )}
                              <Message key={m.id} model={{
                                type: "text",
                                payload: m.content.body,
                                direction: m.direction,
                                position: "normal"
                              }}>
                                {index === 0 && <Message.Header>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "0.7rem",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <Typography component="span" variant="caption" sx={{ fontWeight: 600 }}>
                                      {(m?.data as any)?.activity && <Typography component="span" variant="caption" sx={{ fontWeight: 600, }}>
                                        {(m?.data as any)?.activity}
                                      </Typography>}
                                      {`${((m?.data as any)?.activity && activeConversation?.participants.length > 2 && m.direction === MessageDirection.Incoming) ? ' by ' : ''}`}
                                      {(activeConversation?.participants.length > 2 && m.direction === MessageDirection.Incoming) && <Typography component="span" variant="caption" sx={{ fontWeight: 600, }}>
                                        {m.sender?.id ? getUser(m.sender.id)?.username ?? "Guest" : "Guest"}
                                      </Typography>}
                                    </Typography>
                                  </Box>
                                </Message.Header>}
                              </Message>
                            </React.Fragment>
                          )
                        })}
                      </MessageGroup.Messages>
                    </MessageGroup>
                  )
                }
              )}
              {currentMessages.length === 0 &&
                <Stack sx={{ display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                  <Typography variant="body2" sx={{ color: '#999' }}>
                    Send a message to start a conversation
                  </Typography>
                </Stack>
              }
            </MessageList>}
            { authStatus === 'authenticated' && <MessageInput style={{ paddingTop: 10, paddingBottom: 10 }} attachButton={false} placeholder="Type message here" onSend={handleSend} />}
          </ChatContainer>          
          {sidebar}
        </MainContainer>
      </ServiceStateContext.Provider>
    </>)
}



